import type { RedirectLoginOptions } from "@auth0/auth0-react";

const isAuth0Callback = (search: string): boolean => {
	const params = new URLSearchParams(search);
	return (params.has("code") || params.has("error")) && params.has("state");
};

export const currentReturnTo = (): string => {
	const { pathname, search, hash } = window.location;
	if (isAuth0Callback(search)) return pathname;
	return `${pathname}${search}${hash}`;
};

export const loginRedirectOptions = (): RedirectLoginOptions => ({
	appState: { returnTo: currentReturnTo() },
});
